import { ApplicationRating, FeedbackRequired } from '../types/feedback/feedback.types';
import { createLoadActions } from './_prototypes/action-reducers/actions/load.actions';
import { initializeLoadStateWithoutData, LoadState } from './_prototypes/action-reducers/state/load.state';
import { combineReducers, createSelector, props } from '@ngrx/store';
import { createLoadReducer } from './_prototypes/action-reducers/reducers/load.reducers';
import { CoreState } from './core.slice';
import { loadSelector } from './_prototypes/action-reducers/selectors/load.selectors';

const PREFIX = '[FEEDBACK]';
export const stateKey = 'feedback';

export interface FeedbackState {
  feedback: LoadState<Record<never, never>, FeedbackRequired>;
  sendApplicationFeedback: LoadState<{ rating: ApplicationRating }, void>;
  sendWeekFeedback: LoadState<{ code: number }, void>;
}

export const checkFeedback = createLoadActions<Record<string, never>, FeedbackRequired>(
  `${PREFIX} checkFeedback`,
  props<Record<string, never>>()
);

export const sendApplicationFeedback = createLoadActions<{ rating: ApplicationRating; feedback?: string }, void>(
  `${PREFIX} sendApplicationFeedback`,
  props<{ rating: ApplicationRating; feedback?: string }>()
);

export const sendWeekFeedback = createLoadActions<{ code: number }, void>(
  `${PREFIX} sendWeekFeedback`,
  props<{ code: number }>()
);

export const feedbackReducers = combineReducers<FeedbackState>({
  feedback: createLoadReducer(initializeLoadStateWithoutData<Record<string, never>, FeedbackRequired>(), checkFeedback),
  sendApplicationFeedback: createLoadReducer(
    initializeLoadStateWithoutData<{ rating: ApplicationRating }, void>(),
    sendApplicationFeedback
  ),
  sendWeekFeedback: createLoadReducer(initializeLoadStateWithoutData<{ code: number }, void>(), sendWeekFeedback),
});

const stateSelector = createSelector(
  (state: CoreState) => state,
  (state: CoreState) => state[stateKey] as FeedbackState
);

const sendApplicationFeedbackSelector = createSelector(stateSelector, (state) => state.sendApplicationFeedback);
export const sendApplicationFeedbackState = loadSelector(sendApplicationFeedbackSelector);

const sendWeekFeedbackSelector = createSelector(stateSelector, (state) => state.sendWeekFeedback);
export const sendWeekFeedbackState = loadSelector(sendWeekFeedbackSelector);

const checkFeedbackSelector = createSelector(stateSelector, (state) => state.feedback);
export const checkFeedbackState = loadSelector(checkFeedbackSelector);
